import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
import errorCode from '@/utils/errorCode'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 公开接口请求实例（未登录即可访问的接口：导航栏、新闻、政策、公示公告、维权资讯、信息公开等）
// 默认不传 openid，不传 token
// 特殊情况：调用方显式传 sm2PublicKey 时，会把它放入 publicKey 请求头（供 /ldgx/security/valid 等接口使用）
const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 1000 * 60 * 5,
});

// 请求拦截器
request.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json';
        // 仅当调用方显式传入 sm2PublicKey 时才加 publicKey 头（特殊接口用，如 /ldgx/security/valid）
        // 不加 openid
        if (config.sm2PublicKey) {
            config.headers['publicKey'] = config.sm2PublicKey
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    res => {
        const code = res.data.code || 200;
        let msg = errorCode[code] || res.data.msg || errorCode['default']
        if (code === 401) {
            MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                store.dispatch('LogOut').then(() => {
                    location.href = '/';
                }).catch(() => {
                    location.href = '/';
                })
            })
        } else if (code === 500) {
            Message({
                message: msg,
                type: 'error'
            })
            return Promise.reject(new Error(msg))
        } else if (code === 5001) {
            let second = 5
            MessageBox.confirm('当前页面停留时间过长，请重新操作', '系统提示', {
                confirmButtonText: '刷新页面',
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                type: 'warning'
            }).then(() => {
                location.reload()
            }).catch(() => {
            })
            let timer = setInterval(() => {
                second -= 1
                if (second == 0) {
                    MessageBox.close()
                    clearInterval(timer)
                    location.reload()
                }
            }, 1000)
            return Promise.reject(new Error(msg))
        } else if (code !== 200) {
            Notification.error({
                title: msg
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        return Promise.reject(error);
    }
);

export default request;
